module.exports = __webpack_public_path__ + "static/media/heroimg_desktop.3a30fa2a.jpg";